export default __webpack_public_path__ + "static/media/ic_bnb_16.2561800d.svg";